/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState } from 'react';
import { Icon, Image } from 'semantic-ui-react';
import { useLocation } from 'react-router-dom';
import { shape } from 'prop-types';
import { haveItemInArrayByKey } from 'Helpers/utils';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';

import styles from './style.less';
import SubItems from './SubItems';
import classNames from 'classnames';

const ItemWithChildren = props => {
  const { t } = useTranslation();
  const location = useLocation();
  const {
    collapsed,
    item: { children, id, icon },
  } = props;
  const [isCollapsed, setCollapsed] = useState(
    !haveItemInArrayByKey(children, { link: location.pathname }, 'link'),
  );

  const handleClick = () => {
    setCollapsed(prevState => !prevState);
  };

  return (
    <li className={classNames([styles.menu], { [styles.collapsed]: collapsed })}>
      <a
        aria-expanded={!isCollapsed}
        data-toggle="collapse"
        onClick={handleClick}
        className={classnames([styles.menuSingle], {
          [styles.menuSingleExpand]: !isCollapsed,
          [styles.menuTitleActive]: haveItemInArrayByKey(
            children,
            { link: location.pathname },
            'link',
          ),
        })}>
        <div>
          <Image
            className={
              haveItemInArrayByKey(children, { link: location.pathname }, 'link')
                ? styles.iconImageActive
                : styles.iconImage
            }
            src={icon}
            alt="icon menu"
          />
          <span>{t(id)}</span>
        </div>
        {isCollapsed ? <Icon name="angle down" /> : <Icon name="angle up" />}
      </a>
      <SubItems
        className={classnames({
          [styles.menuWithChild]: !isCollapsed,
          [styles.menuWithChildCollapsed]: isCollapsed,
        })}
        items={children}
      />
    </li>
  );
};

ItemWithChildren.propTypes = {
  item: shape({}).isRequired,
};

export default ItemWithChildren;
